import q from 'q'
import orgamax from 'ampersand-app'
import config from 'config'
import AmpersandRestCollection from 'ampersand-rest-collection'
import BaseModel from 'base/model/base_model'
import request from '@/modules/base/util/request'

export default AmpersandRestCollection.extend({
  model: BaseModel,

  constructor: function BaseRestCollection() {
    AmpersandRestCollection.apply(this, arguments)
  },

  ajaxConfig: function() {
    return orgamax.user.token
      ? { headers: { authorization: `Bearer ${orgamax.user.token}` } }
      : {}
  },

  fetch: function(options) {
    const deferred = q.defer()
    const promise = deferred.promise

    options = options || {}
    options.success = deferred.resolve

    options.error = function(collection, xhr, options) {
      // if the xhr was aborted on purpose, this is not considered
      // an error. neither rejection (throws an error) nor resolving
      // (continues the promise chain) make sense here
      if (xhr.aborted) {
        return
      }

      // test for json parse errors and explicitely point them out
      // because ampersand-sync and the underlying xhr module don't
      try {
        JSON.parse(xhr.body)
        deferred.reject(new Error('fetch error'))
      } catch (err) {
        err.message = `JSON.parse error: ${err.message}`
        deferred.reject(err)
      }
    }
    AmpersandRestCollection.prototype.fetch.call(this, options)
    return promise
  },

  initialize: function() {
    // logout on expired token
    this.on('error', function(collection, xhr, options) {
      if (xhr.status === 401) {
        orgamax.user.logout()
      }
    })
  },

  parse: function(res) {
    // Normally, data in REST collection responses is wrapped in an object with a value property.
    // It also can happen, that a rest collection is also used as a child/collection inside another model.
    // In this case, the data is not wrapped with a value property and return statement would be undefined, so the
    // model.fetch() would break.
    return this.parent ? res : res.data
  },

  // store request in registry while it is running
  sync: function(method, model, options) {
    options = options || {}
    options.timeout = options.timeout || config.requestTimeout
    const xhr = AmpersandRestCollection.prototype.sync.call(this, method, model, options)

    // concurrent requests are not aborted
    if (options.isConcurrent) {
      xhr.isConcurrent = true
    }

    orgamax.registry.store(xhr)
    return xhr
  },

  save: function(data) {
    if (!this.url) {
      throw new Error('A "url" property must be specified in the collection.')
    }
    data = data || this.toJSON()
    return request(this.url, {
      auth: true,
      method: 'PUT',
      data,
    })
  },
})
